/**
 * BrandMark - ClaimGuru "C" sigil.
 * Cyan ring with an inset bar that reads as both "C" and a chart-line marker.
 * Inherits color via currentColor for the ring; fill uses the cyan token.
 */
export default function BrandMark({ className = 'h-7 w-7' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="cg-ring" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="var(--v3-accent-cyan)" stopOpacity="1" />
          <stop offset="100%" stopColor="var(--v3-accent-cyan)" stopOpacity="0.55" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="8" stroke="url(#cg-ring)" strokeWidth="1.5" />
      <path
        d="M22.5 11.5a7.5 7.5 0 1 0 0 9"
        stroke="var(--v3-accent-cyan)"
        strokeWidth="2.25"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="22.5" cy="16" r="1.5" fill="var(--v3-accent-cyan)" />
    </svg>
  )
}
